import { IPFS_GATEWAY } from '../index'
import { Team } from './types'

const teams: Team[] = [
  {
    id: 1,
    name: 'Blue',
    description: "The punch of the most short wave visible color.",
    images: {
      lg: 'blue-lg.png',
      md: 'blue-md.png',
      sm: 'blue-sm.png',
      alt: 'blue-alt.png',
      ipfs: `${IPFS_GATEWAY}/QmXKzSojwzYjtDCVgR6mVx7w7DbyYpS7zip4ovJB9fQdMG/syrup-storm.png`,
    },
    background: 'syrup-storm-bg.svg',
    textColor: '#191326',
    users: 0,
    points: 0,
  },
  {
    id: 2,
    name: 'Green',
    description: "The balance of a wavelength in the middle of the visible spectrum.",
    images: {
      lg: 'green-lg.png',
      md: 'green-md.png',
      sm: 'green-sm.png',
      alt: 'green-alt.png',
      ipfs: `${IPFS_GATEWAY}/QmXKzSojwzYjtDCVgR6mVx7w7DbyYpS7zip4ovJB9fQdMG/fearsome-flippers.png`,
    },
    background: 'fearsome-flippers-bg.svg',
    textColor: '#FFFFFF',
    users: 0,
    points: 0,
  },
  {
    id: 3,
    name: 'Red',
    description: 'The heat of the wavelength closest to warmth.',
    images: {
      lg: 'red-lg.png',
      md: 'red-md.png',
      sm: 'red-sm.png',
      alt: 'red-alt.png',
      ipfs: `${IPFS_GATEWAY}/QmXKzSojwzYjtDCVgR6mVx7w7DbyYpS7zip4ovJB9fQdMG/chaotic-cakers.png`,
    },
    background: 'chaotic-cakers-bg.svg',
    textColor: '#191326',
    users: 0,
    points: 0,
  },
]

export default teams
